// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2viJV","disabled":"FileBtn_disabled__tkPvn","warn":"FileBtn_warn__3VaQd","fade":"FileBtn_fade__2SEYC"};